export class routes {
  private static Url = '';

  public static get baseUrl(): string {
    return this.Url;
  }

  public static get chat(): string {
    return this.baseUrl + '/chat';
  }

  public static get campaigns(): string {
    return this.baseUrl + '/campaigns';
  }

  public static get login(): string {
    return this.baseUrl + '/login';
  }

  public static get adminDashboard(): string {
    return this.baseUrl + '/dashboard/admin-dashboard';
  }
  public static get doctorDashboard(): string {
    return this.baseUrl + '/dashboard/doctor-dashboard';
  }
  public static get patientDashboard(): string {
    return this.baseUrl + '/dashboard/patient-dashboard';
  }
  public static get patientsList(): string {
    return this.baseUrl + '/patients';
  }
  public static get setting(): string {
    return this.baseUrl + '/setting';
  }
  public static get settings(): string {
    return this.baseUrl + '/settings';
  }
  public static get hcpRegistration(): string {
    return this.baseUrl + '/hcp-registration';
  }
  public static get error404(): string {
    return this.baseUrl + '/error/error404';
  }
  public static get error500(): string {
    return this.baseUrl + '/error/error500';
  }
}
